import { AbstractControl, ValidationErrors } from '@angular/forms';
import { isValidPhoneNumber } from 'libphonenumber-js/min';

/**
 * This validator should be attached at the formGroup level
 */
export function phoneNumberWithCountryValidator(
  phoneNumberControlName = 'phoneNumber',
  countryCodeControlName = 'phoneNumberCountryCode',
  errorKey: string = 'invalidPhoneNumber'
) {
  return (group: AbstractControl): ValidationErrors | null => {
    const countryCodeControl = group.get(countryCodeControlName);
    const phoneNumberControl = group.get(phoneNumberControlName);

    if (!countryCodeControl?.value || !phoneNumberControl?.value) {
      return null;
    }

    const countryCode = countryCodeControl.value;
    const phoneNumber = phoneNumberControl.value;

    let isValid: boolean;

    try {
      isValid = isValidPhoneNumber(phoneNumber, countryCode);
    } catch {
      isValid = false;
    }

    if (isValid) {
      const currentErrors = phoneNumberControl.errors;
      if (currentErrors) {
        delete currentErrors[errorKey];
        const hasOtherErrors = Object.keys(currentErrors).length > 0;
        phoneNumberControl.setErrors(hasOtherErrors ? currentErrors : null);
      }
      return null;
    } else {
      const currentErrors = phoneNumberControl.errors || {};
      currentErrors[errorKey] = true;
      phoneNumberControl.setErrors(currentErrors);
      return { [errorKey]: true };
    }
  };
}
